import { Model, PlayingCardOption } from '../sharedBetweenServerAndClient__DO_NOT_EDIT/types'

export const deserializeUserHand = (userHand: Model.SerializedUserHand): Model.UserHand => ({
  ...userHand,
  cards: userHand.cards.map((card) => window.atob(card) as PlayingCardOption),
})
